import { ADD_MENU_ITEM, REMOVE_MENUS } from '../mutation-types'

const state = {
    menus: []
}
  
  const mutations = {
    [ADD_MENU_ITEM] (state, menu) {
      state.menus.push(menu);
    },
    [REMOVE_MENUS] (state)  {
      state.menus = []
    }
  }
  
  export default {
    state,
    mutations
  }